import deepmerge from '../tools/deepmerge';
export { userlikeModule };

const defaultConfig = {
    widgets: [],
    loggedIn: false,
    idUser: 1,
    idProduct: 0,
    route: '',
    countryIdByIp: '',
    data: [],
    selectedWidget: null,
    currentLocale: '',
};

const configKeyMapping = {
    w: 'widgets',
    l: 'loggedIn',
    u: 'idUser',
    p: 'idProduct',
    r: 'route',
    i: 'countryIdByIp',
    d: {
        data: {
            f: 'firstname',
            l: 'lastname',
            e: 'email',
            c: 'company',
            p: 'productName',
        },
    },
    cl: 'currentLocale',
    hf: 'hasFeatureAllowChat',
    sw: 'selectedWidget',
    clb: 'callbacks',
    ar: 'allowedRoutes',
};

let config = {};
let routeConfig;
let productConfig;

function userlikeModule(params) {
    extractConfigParams();
    selectWidget();

    window.userlikeReady = function() {
        const productName =
            Object.keys(config.data).length === 0 ? 'Anonym' : config.data.productName;
        if (
            Object.prototype.hasOwnProperty.call(config.callbacks, 'userProductWasChanged') &&
            config.callbacks.userProductWasChanged(productName)
        ) {
            const userData = getUserData();
            window.userlike.setData(userData);
            window.userlike.userlikeUpdateAPI();
        }
    };

    window.userlikeRemoteReady = function() {
        if (
            typeof productConfig === 'undefined' ||
            productConfig === null ||
            productConfig === false
        ) {
            return false;
        }

        if (productConfig === true) {
            window.userlike.userlikeRemoteApiModeNormal(); //start normal
        } else if (
            Object.prototype.hasOwnProperty.call(productConfig, 'register') &&
            !Object.prototype.hasOwnProperty.call(productConfig, 'proactive')
        ) {
            window.userlike.userlikeRemoteApiModeRegister(); //start normal with register
        } else if (
            Object.prototype.hasOwnProperty.call(productConfig, 'proactive') &&
            !Object.prototype.hasOwnProperty.call(productConfig, 'register')
        ) {
            window.userlike.userlikeRemoteApiModeProactivePassive(parseInt(productConfig.proactive)); //start proactive
        } else {
            window.userlike.userlikeRemoteApiModeProactivePassiveAndRegister(
                parseInt(productConfig.proactive)
            ); //start proactive with register
        }

        if (config.loggedIn === true) {
            const userData = getUserData();
            window.userlike.setData(userData);
        }
    };

    /**
     * select and start widget
     */
    function selectWidget() {
        routeConfig = getRouteConfigProducts();
        productConfig = getProductConfig(routeConfig);

        if (config.selectedWidget !== null) {
            if (Object.prototype.hasOwnProperty.call(config.callbacks, 'addApiScriptToBody')) {
                config.callbacks.addApiScriptToBody(config.selectedWidget);
            }
        }
    }

    /**
     * get user data object for userlike setData function
     * @returns {{user: {name: string, email: *, additional01: string, additional02: *, additional03: number}}}
     */
    function getUserData() {
        const userData = {
            user: {
                name: `${ config.data.firstname } ${ config.data.lastname }`,
                email: config.data.email,
                additional01: config.data.company,
                additional02: config.data.productName,
                additional03: config.idUser,
            },
        };

        return userData;
    }

    /**
     * get widget type to start
     * @param routeConfig
     * @returns {*}
     */
    function getProductConfig(routeConfig) {
        for (const productIdString in routeConfig) {
            const idProduct = parseInt(productIdString.split(':')[1]);
            if (idProduct === config.idProduct) {
                return routeConfig[productIdString];
            }
        }

        return false;
    }

    /**
     * get products cofiguration object
     * @returns {null}
     */
    function getRouteConfigProducts() {
        const chatConfigByLocale = config.allowedRoutes;
        for (const routsAreaName in chatConfigByLocale) {
            if (Object.prototype.hasOwnProperty.call(chatConfigByLocale[routsAreaName]['sites'], config.route)) {
                return chatConfigByLocale[routsAreaName]['sites'][config.route]['products'];
            }
        }

        return null;
    }

    /**
     * extract and marge parameters to config
     * @returns {boolean}
     */
    function extractConfigParams() {
        const paramsArray = {};
        for (const minifiedKey in params) {
            const configKey = getKeyByMinified(minifiedKey, configKeyMapping);
            if (false !== configKey) {
                if (typeof configKey === 'string') {
                    paramsArray[configKey] = params[minifiedKey];
                } else {
                    paramsArray[Object.keys(configKey)[0]] = extractData(params[minifiedKey]);
                }
            }
        }
        config = deepmerge(defaultConfig, paramsArray);

        return true;
    }

    /**
     * extract user data config
     * @param dataParams
     * @returns {{}}
     */
    function extractData(dataParams) {
        if (typeof dataParams === 'object' && Object.keys(dataParams).length > 0) {
            const confData = {};
            for (const minifiedKey in dataParams) {
                const configKey = getKeyByMinified(minifiedKey, configKeyMapping['d']['data']);
                if (false !== configKey) {
                    confData[configKey] = dataParams[minifiedKey];
                }
            }

            return confData;
        }

        return {};
    }

    /**
     * get key mapped to minifiedKey
     *
     * @param minifiedKey
     * @returns {*}
     */
    function getKeyByMinified(minifiedKey, mappingArray) {
        if (Object.prototype.hasOwnProperty.call(mappingArray, minifiedKey)) {
            return mappingArray[minifiedKey];
        }

        return false;
    }
}
